import { render } from "./contrattiCollaborazione.vue?vue&type=template&id=2d7594d0&ts=true"
import script from "./contrattiCollaborazione.vue?vue&type=script&lang=ts"
export * from "./contrattiCollaborazione.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__